import { Box, Center, Icon, Text } from "@chakra-ui/react";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { RoutesMap } from "../../routes";
import { getAppVersion } from "../../utils";
import { Logo } from "../../components/shared/Logo";

export function LoginPageLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleBackClick = (): void => {
    navigate(RoutesMap.login.index);
  };

  return (
    <Box position="relative" h="100svh">
      <Center position="relative">
        <Box py="25px" minW="300px" display="flex" alignItems="center" flexDir="column" position="relative">
          {location.pathname === RoutesMap.login.otp && (
            <Box onClick={handleBackClick} cursor="pointer" position="absolute" top="28px" left={0}>
              <Icon as={ChevronLeftIcon} boxSize="6" color="gray.500" />
            </Box>
          )}
          <Logo />
        </Box>
      </Center>
      <Outlet />

      {location.pathname === RoutesMap.login.index && (
        <Text
          position="absolute"
          bottom="51px"
          w="100%"
          fontSize="14px"
          textAlign="center"
        >
          {getAppVersion()}
        </Text>
      )}
    </Box>
  );
}
